/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/save-1214294': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M18 2H6a1 1 0 00-1 1v18a1 1 0 001.65.76L12 17.27l5.29 4.44A1 1 0 0018 22a.84.84 0 00.38-.08A1 1 0 0019 21V3a1 1 0 00-1-1zm-1 16.86l-4.36-3.66a1 1 0 00-1.28 0L7 18.86V4h10z"/>'
  }
})
